import { Component, OnInit } from '@angular/core';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';

@Component({
  selector: 'app-terms-conditions-popover',
  templateUrl: './terms-conditions-popover.component.html',
  styleUrls: ['./terms-conditions-popover.component.scss'],
})
export class TermsConditionsPopoverComponent implements OnInit {

  constructor(
    public unfocusService: UnfocusElementService
  ) { }

  ngOnInit() { }

  goToLink(ev, file) {
    this.unfocusService.unfocus(ev);
    var url = 'assets/content/legal-docs/' + file + '.pdf';
    window.open(url, "_system", "location=yes");
  }
}
